import { api, returningError } from 'src/api';
import { store } from 'src/redux';
import { getPrefixEndpoints } from 'src/utils';
import { getFirestore, doc, getDoc } from 'firebase/firestore';
import { remoteConfigApp } from 'src/api/remoteConfig';

const db = getFirestore(remoteConfigApp, 'goodlook');

export const getEmployees = async () => {
   try {
      const { data }: any = await api.get(`/${getPrefixEndpoints(store.getState().app.locale)}/v1/employees`);
      return { ...data, success: 'true' };
   } catch (error) {
      return returningError(error);
   }
};

export const getGoodlookeroById = async (id: string) => {
   try {
      const docRef = doc(db, 'goodlookeros', id);
      const docSnap = await getDoc(docRef);
      
      if (docSnap.exists()) {
         console.log('Found goodlookero from Firestore:', docSnap.data());
         return { ...docSnap.data(), id: docSnap.id, success: 'true' };
      }

      return { data: '', errors: 'Goodlookero no encontrado', success: 'false' };
   } catch (error: any) {
      console.error('Error fetching goodlookero from Firestore:', error);
      return { data: '', errors: error.message, success: 'false' };
   }
};
